import { SvgIcon, SvgIconProps } from '@mui/material';

const ControlPointIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <mask
        id="mask0_2006_93"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <path d="M0 0H40V40H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2006_93)">
        <path
          d="M9.80542 34.0554C6.85181 32.926 4.47917 31.0833 2.6875 28.5275C0.895833 25.9719 0 23.1224 0 19.9787C0 16.8354 0.900417 13.9883 2.70125 11.4375C4.50236 8.88666 6.87042 7.04638 9.80542 5.91666V9.02791C7.65736 10.0185 5.94903 11.5018 4.68042 13.4779C3.41208 15.4537 2.77792 17.6185 2.77792 19.9721C2.77792 22.3518 3.41208 24.5232 4.68042 26.4862C5.94903 28.449 7.65736 29.9351 9.80542 30.9446V34.0554ZM25 34.9721C22.9167 34.9721 20.9653 34.5762 19.1458 33.7846C17.3264 32.9929 15.7431 31.9235 14.3958 30.5762C13.0486 29.229 11.9792 27.6457 11.1875 25.8262C10.3958 24.0068 10 22.0554 10 19.9721C10 17.8887 10.3958 15.9374 11.1875 14.1179C11.9792 12.2985 13.0486 10.7151 14.3958 9.36791C15.7431 8.02069 17.3264 6.95124 19.1458 6.15958C20.9653 5.36791 22.9167 4.97208 25 4.97208C27.0833 4.97208 29.0347 5.36791 30.8542 6.15958C32.6736 6.95124 34.2569 8.02069 35.6042 9.36791C36.9514 10.7151 38.0208 12.2985 38.8125 14.1179C39.6042 15.9374 40 17.8887 40 19.9721C40 22.0554 39.6042 24.0068 38.8125 25.8262C38.0208 27.6457 36.9514 29.229 35.6042 30.5762C34.2569 31.9235 32.6736 32.9929 30.8542 33.7846C29.0347 34.5762 27.0833 34.9721 25 34.9721Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default ControlPointIcon;
